'use client'

import { useQuery } from '@tanstack/react-query'

import { getAudioTagList } from '../../services/audio'

import { AUDIO_TAG_LIST_KEY } from './audio-keys'

export const useAudioTagList = () => {
  return useQuery({
    queryKey: [AUDIO_TAG_LIST_KEY],
    queryFn: () => getAudioTagList(),
    staleTime: 1000 * 60 * 10,
  })
}
